import { Grid, Divider, Button, Typography, Box } from "@material-ui/core";
import { makeStyles, ThemeProvider } from "@material-ui/core";
import React, { useEffect, useRef } from "react";
import { useMediaQuery } from "react-responsive";
import { history } from "../../../helpers/index";
import { routePaths } from "../../config/route-paths";
import { useSelector } from "react-redux";
import { useState } from "react";
import { commonService } from "../../../services";
import { useLayoutEffect } from "react";
import { HomeRoutes } from "../../config/routes";
import { Skeleton } from "@material-ui/lab";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  loginContainer: {
    // maxWidth: "80%",
    height:"100%",
    textAlign: "center",
    backgroundColor: theme.palette.eWhite.base+"e6",
    position: "relative",
    borderRadius: 6,
    margin: "0px auto",
  },
  smLoginContainer: {
    marginTop: "5%",
    maxWidth: "90%",
    background: theme.palette.eWhite.base,
    opacity: 0.93,
    textAlign: "center",
    borderRadius: 6,
    margin: "auto",
  },
  tenantLogo: {
    width: "45%",
    margin:"0.5em 0",
    height: "auto",
    overflow: "auto",
    objectFit: "contain",
  },
  smTenantLogo: {
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    width: "120%",
    height: "55%",
    overflow: "auto",
    objectFit: "contain",
    marginTop: "28px",
    marginBottom: "25px",
    maxWidth:"60%"
  },
  dividerColor: {
    backgroundColor: theme.palette.eLight.base,
  },
  abjLogo: {
    width:"30%",
    height: "auto",
    objectFit: "contain",
    backgroundRepeat: "no-repeat",
    opacity: 1,
    alignSelf:"center"
  },
  aboveLogoContainer: {
    opacity: 0.9,
  },
  mtb5:{
      margin: "0rem 0rem 0rem 0rem",
  },
  abjayonLogoGrid:{
    marginTop: "2rem",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    marginBottom:"0.3rem"
  }
}));

let quickPayLabel = {};
let tenantImg = {};
let abjayonImg = {};
let tenantFallback = {};
function ELoginSection(props) {
  const {t:labels ,ready:labelsReady} = useTranslation("label-E_IMPRESSA_LOGO") ;
  const classes = useStyles();
  const [quickPay, setQuickPay] = useState("");
  const [tenantLogo, setTenantLogo] = useState("");
  const [abjayonLogo, setAbjayonLogo] = useState("");
  let loginRef = useRef(null);

  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 550px)" });
  let quickPayRoute = (e) => {
    history.push(routePaths.QUICK_PAY);
  };

  tenantFallback = useSelector(
    (state) => state?.labels?.data?.getLabels?.E_IMPRESSA_LOGO
  );

  tenantImg = useSelector(
    (store) =>
      store?.parametersWidgets?.ParameterLookup?.E_CLIENT_LOGO
  );

  abjayonImg = useSelector(
    (store) => store?.parametersWidgets?.ParameterLookup?.E_IMPRESACX_LOGO
  );

  useEffect(() => {
    tenantImg && commonService.getAssestUrl(tenantImg).then((res) => setTenantLogo(res));
  }, [tenantImg]);

  useEffect(() => {
    abjayonImg && commonService.getAssestUrl(abjayonImg).then((res) => setAbjayonLogo(res));
  }, [abjayonImg]);
  useLayoutEffect(() => {
    if (loginRef.current) {
      //  props.setBoxHeight(loginRef.current.clientHeight)
    }
  }, [loginRef.current]);

  return (
    <>
      {isTabletOrMobile ? (
        <React.Fragment>
          <Grid
            container
            className={classes.smLoginContainer}
            direction="column"
          >
            <Grid item className={classes.mtb5}>
              {tenantLogo ? <img
                src={tenantLogo.assetPath}
                className={classes.smTenantLogo}
                alt={
                  tenantLogo && labelsReady? labels("E_LOGIN_FOOTER_LOGO_FALLBACK") : ""
                }
              ></img> :
              <Skeleton/>}
              
            </Grid>
            <Grid item xs={12}>
            <HomeRoutes />
            </Grid>
            {/* <Grid
              item
              style={{
                height: "15%",
                marginTop: "0.5rem",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
              }}
            >
              {abjayonLogo ? 
              <img
              src={abjayonLogo.assetPath}
              alt={
                abjayonLogo && labelsReady? labels("E_LOGIN_FOOTER_LOGO_FALLBACK") : ""
              }
              className={classes.abjLogo}
            ></img> :
            <Skeleton/>
              }
              
            </Grid> */}
            <Divider className={classes.dividerColor} />
          </Grid>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Grid container ref={loginRef} className={classes.loginContainer} direction="row" justify="space-between" alignContent="center">
                <Grid item xs={12} zeroMinWidth className={classes.mtb5}>
                  {tenantLogo?  <img
                    src={tenantLogo.assetPath}
                    className={classes.tenantLogo}
                    alt={
                      tenantLogo &&  labelsReady? labels("E_LOGIN_FOOTER_LOGO_FALLBACK") : ""
                    }
                  ></img> :
                  <Skeleton/> }
                 
                </Grid>

            <Grid item xs={12}>
            <HomeRoutes />
            </Grid>
            {/* <Grid item xs={12} className={classes.abjayonLogoGrid}>
              {abjayonLogo?  <img
                src={abjayonLogo.assetPath}
                className={classes.abjLogo}
                alt={
                  abjayonLogo &&  labelsReady? labels("E_LOGIN_FOOTER_LOGO_FALLBACK") : ""
                }
              ></img> :
              <Skeleton/>}
             
            </Grid> */}
          </Grid>
        </React.Fragment>
      )}
    </>
  );
}
export default ELoginSection;
